module.exports = __webpack_public_path__ + "images/assets/ff11f25075bee85a159148448cfd6bef.svg";